// extracted by mini-css-extract-plugin
export default {"list":"ModalBookmark_list__fRXZ3","item":"ModalBookmark_item__RSFet","photo":"ModalBookmark_photo__P84aF"};